import type { WidgetSkeletonProps } from '../widget-registry';

export function DateSelectorSkeleton({
  compact = false,
}: {
  compact?: boolean;
}) {
  const count = compact ? 3 : 5;
  return (
    <div>
      {!compact && (
        <div className="force-light:bg-gray-200 mb-3 h-4 w-40 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
      )}
      <div className="flex gap-2 overflow-hidden">
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            className={`force-light:bg-gray-200 flex-shrink-0 animate-pulse rounded-[10px] bg-gray-200 dark:bg-gray-700 ${
              compact ? 'h-[38px] w-[38px]' : 'h-[74px] w-[72px]'
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default function CalendarBookingSkeleton(_props: WidgetSkeletonProps) {
  return (
    <div>
      <div className="mb-4 flex items-start gap-3">
        <div className="h-5 w-5 flex-shrink-0 animate-pulse rounded bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-5 w-28 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-48 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
      <DateSelectorSkeleton />
    </div>
  );
}
